/**
 * External dependencies
 */
import React, { useMemo } from "react";
import classNames from "classnames";

/**
 * Configuration
 */
import config from "../config";

const NewsItem = ({ title, link, date, date_formatted }) => {
	const componentClass = classNames(
		"em-block-list-item",
		"animated",
		"duration--fast",
		"wrapper-link",
		"fadeIn"
	);

	return (
		<article className={componentClass}>
			<a href={link} className="em-block-list__link">
				<div className="em-block-list__content">
					<h3 className="em-block-list__title">{title}</h3>
					<time dateTime={date_formatted} className="em-block-list__date">
						{date}
					</time>
				</div>
			</a>
		</article>
	);
};

export default NewsItem;
